import React from 'react';
import SettingCard from './SettingCard';
import { panelLabel } from '../../utils/panelLabels';

const DRYING_COLOR = '#d9534f';

const DryingTemperatureSetup = ({ getSettingValue, handleEdit }) => {
  const temperatureSettings = [
    { name: 'drying_temperature_slope', label: 'Slope' },
    { name: 'drying_temperature_offset', label: 'Offset' }
  ];

  const dryingTemperature = getSettingValue('drying_temperature').value;
  const burnerOff = getSettingValue('burner_off_temp');

  // Read only, and deliberately so. Switching the unit recalibrates the
  // sensors and drops the dryer into local mode, which is work for whoever is
  // standing at the machine, not for a browser somewhere else.
  const rawUnit = getSettingValue('temperature_unit').value;
  const unitKnown = rawUnit !== null && rawUnit !== undefined;
  const isCelsius = rawUnit === 1 || rawUnit === '1' || rawUnit === true;

  const unitTile = (active, symbol, name) => (
    <div
      className={`px-6 py-3 rounded-lg text-center transition-colors ${
        active ? 'bg-blue-600 text-white shadow' : 'bg-gray-100 text-gray-400'
      }`}
    >
      <p className="text-xl font-bold">{symbol}</p>
      <p className="text-xs mt-0.5">{name}</p>
    </div>
  );

  return (
    <div className="h-full flex flex-col">
      <div className="grid grid-cols-2 gap-4">
        {temperatureSettings.map((setting) => {
          const settingData = getSettingValue(setting.name);
          return (
            <SettingCard
              key={setting.name}
              name={panelLabel(setting.name, setting.label)}
              value={settingData.value}
              min={settingData.minRange}
              max={settingData.maxRange}
              onEdit={(_, value) => handleEdit(setting.name, value)}
            />
          );
        })}

        {/* Live reading beside the burner cut-off, the way the panel pairs them */}
        <div
          className="rounded-xl p-6 text-center text-white shadow-lg flex flex-col justify-center"
          style={{ backgroundColor: DRYING_COLOR }}
        >
          <p className="text-4xl font-bold leading-none mb-2">
            {dryingTemperature !== null && dryingTemperature !== undefined
              ? parseFloat(dryingTemperature).toFixed(0)
              : '--'}
          </p>
          <p className="text-base font-semibold uppercase tracking-wide opacity-90">
            {panelLabel('drying_temperature', 'Drying Temperature')}
          </p>
        </div>

        <SettingCard
          name={panelLabel('burner_off_temp', 'Burner Off Temperature')}
          value={burnerOff.value}
          min={burnerOff.minRange}
          max={burnerOff.maxRange}
          onEdit={(_, value) => handleEdit('burner_off_temp', value)}
        />
      </div>

      <div className="mt-6 flex flex-col items-center gap-2">
        <div className="flex gap-3">
          {unitTile(unitKnown && !isCelsius, '°F', 'Fahrenheit')}
          {unitTile(unitKnown && isCelsius, '°C', 'Celsius')}
        </div>
        <p className="text-sm text-gray-500">
          Read only &mdash; the temperature unit is set on the dryer panel.
        </p>
      </div>
    </div>
  );
};

export default DryingTemperatureSetup;
